import React from 'react';
import FinanceTabs from '../components/FinanceTabs';

const FinanceTabsApp = (props) => <FinanceTabs {...props} />;

export default FinanceTabsApp;
